import { usePageBreadcrumbs } from '../contexts/BreadcrumbContext';

/**
 * Visual-less shim: pushes the breadcrumb items into the global
 * BreadcrumbContext so they render inside the TopNav's dark-green
 * breadcrumb strip, matching the rest of the site chrome.
 *
 * Historically this component rendered its own grey in-page row; the
 * chrome-level strip is now the single visual source so the experience
 * stays consistent across every page that reports a trail.
 *
 * API (unchanged):
 *   <Breadcrumbs items={[
 *     { label: 'Stickers', to: '/category/stickers' },
 *     { label: 'Die-Cut' },  // current page -- no `to`
 *   ]} />
 */
export const Breadcrumbs = ({ items = [] }) => {
  usePageBreadcrumbs(items);
  return null;
};

export default Breadcrumbs;
